<script>
	import { getContext, onDestroy } from 'svelte'
	import { url } from '../../library/scripts/Setup.svelte'
	import { slide } from 'svelte/transition'
	import { styles } from '../../library/scripts/styles.js'
	import { get_username, get_file_size } from '../../library/scripts/utils'
	import { admin } from '../../library/scripts/PhpHandler.svelte'
	import { validate } from '../../library/scripts/validate.js'
	import { getCookie } from '../../library/scripts/cookie.js'
	import { storeUploader, storeMailImages, storeRemainingStorage } from '../../library/scripts/Store.svelte'
	import { upload_mail_image } from '../../library/scripts/fileUploader.js'
	import TwoCols from '../../library/columLayouts/TwoCols.svelte'
	import Spinner from '../../library/ShadersAndSpinners/SpinnerCircle.svelte'
	import Shader from '../../library/ShadersAndSpinners/Shader.svelte'
	import Alert from '../../modals/Alert.svelte'

	const globals = getContext('globals')
	const fsL = globals.fsL
	const fsXS = globals.fsXS
	const fsS = globals.fsS
	const colorMain = globals.colorMain
	const inputFocus = globals.inputBgFocus
	const inputBg = globals.inputBg
	const buttonBg = globals.buttonBg
	const buttonBgHover = globals.buttonBgHover
	const link = globals.link
	const linkHover = globals.linkHover

	// the user id
	const userID = getCookie('id')
	const user = get_username(userID)

	let selectSendMail = 'test'
	let attrImage = false
	let singleMail
	let addressingMail
	let subjectMail
	let txtMail
	let searchValue
	let archiveMail
	let listMail
	let enterMail
	let placeholder

	let imageObject = null
	let imageName = null

	//type of upload
	let type = 'text'

	//spinner message
	const spinnerInfo = 'send mail'

	let error = false
	let success = false

	//error handling mail
	let alertError = false
	let message = null

	//the single mail content
	let singleMailContent = []

	//timeouts
	let toResponse

	//response messages
	let responseMsg

	//show mail
	let showMail = false

	$: if (listMail) placeholder = 'email'
	$: if (archiveMail) placeholder = 'subject'

	//close alert
	const reset_error = () => {
		alertError = false
	}

	//image
	const upload_image = async () => {
		if (attrImage) {
			if (imageObject.files.length < 1) {
				alertError = true
				message = 'select image'
				return
			}

			if (!addressingMail) {
				alertError = true
				message = 'enter addressing'
				return
			}

			if (!subjectMail) {
				alertError = true
				message = 'enter subject'
				return
			}
			if (!txtMail && !attrImage) {
				alertError = true
				message = 'enter text message'
				return
			}
			type = 'image'
			imageName = imageObject.files[0].name
			storeUploader.set(true)
			upload_mail_image(userID, imageObject)
		}
	}

	$: if ($storeMailImages) send_mail()

	//the send mail function
	const send_mail = async () => {
		//simple error handling
		if (!addressingMail) {
			alertError = true
			message = 'enter addressing'
			return
		}

		if (!subjectMail) {
			alertError = true
			message = 'enter subject'
			return
		}
		if (!txtMail) {
			alertError = true
			message = 'enter text message'
			return
		}

		if (!attrImage) storeUploader.set(true)

		let formData = {
			subject: subjectMail,
			addressing: addressingMail,
			message: txtMail,
			receiver: selectSendMail,
		}

		if (selectSendMail === 'test') {
			formData = { ...formData, userID: userID, type: type, image: imageName }
		}

		if (selectSendMail === 'single') {
			const val = validate('email', singleMail)
			if (!val) {
				alertError = true
				message = 'enter valid email address'
				return
			}
			formData = { ...formData, userID: userID, email: singleMail, type: type, image: imageName }
		}

		if (selectSendMail === 'all') {
			formData = { ...formData, userID: userID, email: 'all', type: 'text', image: imageName }
		}

		const response = await admin({
			cmd: 'send_mail',
			data: formData,
		})

		if (response) {
			storeUploader.set(false)
			mailArchive = get_mailarchive()
			storeMailImages.set(false)
			mailArchive = get_mailarchive()
		}
	}

	//fetch the email addresses from php
	const get_maillist = async () => {
		const emailAddresses = await admin({
			cmd: 'get_maillist',
		})

		return emailAddresses.sort()
	}

	//fetch the email archive from php
	const get_mailarchive = async () => {
		const mailArchive = await admin({
			cmd: 'get_mailarchive',
		})

		return mailArchive
	}

	let mailList = get_maillist()
	let mailArchive = get_mailarchive()

	//only one checkbox can be selected
	const only_one_checkbox = (c) => {
		if (c === 'mailarchive') {
			showMail = false
			listMail = false
		}
		if (c === 'maillist') {
			showMail = false
			archiveMail = false
		}

		//delete the image if user unchecks image
		if (c === 'image') {
			// funny but true -> if checkBox is selected attrImage = false at this state
			if (attrImage) {
				imageObject = null
				imageName = null
				type = 'text'
			}
		}
	}

	const view_mail = async (id) => {
		listMail = false
		archiveMail = false
		showMail = true
		singleMailContent = await admin({
			cmd: 'get_singlemail',
			id: id,
		})
	}

	const close_mail = () => {
		archiveMail = true
		showMail = false
	}

	const delete_archive = async (type, id, name) => {
		const response = await admin({ cmd: 'delete_archive_entry', type: type, id: id, userID: userID })

		if (response.response === 'deleted') mailArchive = get_mailarchive()
		if (mailArchive) {
			showMail = false
			archiveMail = true
			const fSize = get_file_size()
		}
	}

	const send_single = (email) => {
		selectSendMail = 'single'
		singleMail = email
	}

	const delete_mail = async (email) => {
		const response = await admin({ cmd: 'delete_email', mail: email })

		if (response.response === 'deleted') mailList = get_maillist()
	}

	const add_mail = async () => {
		if (enterMail === '' || !enterMail || enterMail == null) return

		//validate mail
		const val = validate('email', enterMail)
		if (val) {
			const response = await admin({ cmd: 'registermail', dummy: false, mail: enterMail })

			if (response.response === 'entered') {
				success = true
				responseMsg = 'email added'
				mailList = get_maillist()
				toResponse = setTimeout(() => {
					success = false
					enterMail = null
				}, 2000)
				return
			}
		}
		error = true
		if (val) responseMsg = 'email already in list'
		if (!val) responseMsg = 'wrong email format'
		toResponse = setTimeout(() => {
			error = false
		}, 2000)
	}
	const start_search = async (cmd) => {
		if (searchValue === '' || !searchValue || searchValue == null) return

		if (cmd === 'maillist') {
			const response = await admin({ cmd: 'searchvalue', list: 'maillist', searchValue: searchValue })

			if (response.response.length === 0) {
				mailList = ['mail not found']
				return
			}

			mailList = response.response
		}

		if (cmd === 'mailarchive') {
			const response = await admin({ cmd: 'searchvalue', list: 'mailarchive', searchValue: searchValue })

			if (response.response.length === 0) {
				mailArchive = [{ subject: '--', date: '--', receiver: 'mail not found' }]
				return
			}

			mailArchive = response.response
		}
	}

	const reset_search = (cmd) => {
		if (cmd === 'maillist') {
			mailList = get_maillist()
			searchValue = null
		}

		if (cmd === 'mailarchive') {
			mailArchive = get_mailarchive()
			searchValue = null
		}
	}

	onDestroy(() => {
		toResponse
	})
</script>

<main transition:slide={{ duration: 1000, delay: 500 }}>
	<TwoCols column="290px" alignHorizontal="start" alignVertical="start">
		<div slot="column1" class="column1">
			<div class="title" use:styles={{ fsL, colorMain }}>SEND MAIL</div>

			<div class="selection_container">
				<ul>
					<li class="sub_title" use:styles={{ colorMain, fsXS }}>test</li>
					<li>
						<input type="radio" data-radio bind:group={selectSendMail} name="test" value="test" />
					</li>
				</ul>

				<ul>
					<li class="sub_title" use:styles={{ colorMain, fsXS }}>single</li>
					<li><input type="radio" data-radio bind:group={selectSendMail} name="single" value="single" /></li>
				</ul>

				<ul>
					<li class="sub_title" use:styles={{ colorMain, fsXS }}>all</li>
					<li><input type="radio" data-radio bind:group={selectSendMail} name="all" value="all" /></li>
				</ul>

				<ul>
					<li style="color:hsl(0,0%,50%);" class="sub_title" use:styles={{ colorMain, fsXS }}>image</li>
					<li>
						<input
							type="checkbox"
							data-checkbox
							bind:checked={attrImage}
							id="attrImage"
							on:click={() => only_one_checkbox('image')}
						/>
					</li>
				</ul>
			</div>
			<div class="input_container">
				{#if attrImage}
					<div in:slide={{ duration: 2000 }}>
						<input
							type="file"
							use:styles={{ fsXS, colorMain, inputBg }}
							data-file
							class="file"
							bind:this={imageObject}
						/>
					</div>
				{/if}

				{#if selectSendMail === 'single'}
					<div transition:slide={{ duration: 2000 }}>
						<input
							type="text"
							use:styles={{ fsXS, colorMain, inputFocus, inputBg }}
							data-text
							placeholder="enter email"
							bind:value={singleMail}
						/>
					</div>
				{/if}

				<input
					type="text"
					use:styles={{ fsXS, colorMain, inputFocus, inputBg }}
					data-text
					placeholder="subject"
					bind:value={subjectMail}
				/>

				<input
					type="text"
					use:styles={{ fsXS, colorMain, inputFocus, inputBg }}
					data-text
					placeholder="addressing"
					bind:value={addressingMail}
				/>
				<textarea bind:value={txtMail} use:styles={{ fsXS, colorMain, inputFocus, inputBg }} placeholder="message" />

				<div class="button_container">
					{#if !attrImage}
						<button on:click={send_mail} use:styles={{ fsXS, colorMain, buttonBg, buttonBgHover }}>send mail</button>
					{:else}
						<button on:click={upload_image} use:styles={{ fsXS, colorMain, buttonBg, buttonBgHover }}>send mail</button>
					{/if}
				</div>
			</div>
		</div>

		<div slot="column2" class="column2">
			<div class="title" use:styles={{ fsL, colorMain }}>MANAGE MAIL</div>
			<div class="selection_container">
				<ul>
					<li class="sub_title" use:styles={{ colorMain, fsXS }}>mail-list</li>
					<li>
						<input
							type="checkbox"
							data-checkbox
							bind:checked={listMail}
							name="maillist"
							on:click={() => only_one_checkbox('maillist')}
						/>
					</li>
				</ul>

				<ul>
					<li class="sub_title" use:styles={{ colorMain, fsXS }}>archive</li>
					<li>
						<input
							type="checkbox"
							data-checkbox
							bind:checked={archiveMail}
							name="mailarchive"
							on:click={() => only_one_checkbox('mailarchive')}
						/>
					</li>
				</ul>
			</div>

			<div>
				{#if !error && !success}
					<input
						type="text"
						use:styles={{ fsXS, colorMain, inputFocus, inputBg }}
						data-text
						data-button
						placeholder="email address"
						bind:value={enterMail}
					/>

					<button on:click={add_mail} use:styles={{ fsXS, colorMain, buttonBg, buttonBgHover }}>add mail</button>
				{/if}

				{#if success}
					<div class="success" use:styles={{ fsXS, colorMain }}>{responseMsg}</div>
				{/if}

				{#if error}
					<div class="error" use:styles={{ fsXS, colorMain }}>{responseMsg}</div>
				{/if}
			</div>
			{#if archiveMail || listMail}
				<div transition:slide={{ duration: 500 }}>
					<input
						type="text"
						use:styles={{ fsXS, colorMain, inputFocus, inputBg }}
						data-text
						data-button
						{placeholder}
						bind:value={searchValue}
					/>

					{#if listMail}
						<button on:click={() => start_search('maillist')} use:styles={{ fsXS, colorMain, buttonBg, buttonBgHover }}
							>search</button
						>

						<button on:click={() => reset_search('maillist')} use:styles={{ fsXS, colorMain, buttonBg, buttonBgHover }}
							>reset</button
						>
					{:else}
						<button
							on:click={() => start_search('mailarchive')}
							use:styles={{ fsXS, colorMain, buttonBg, buttonBgHover }}>search</button
						>

						<button
							on:click={() => reset_search('mailarchive')}
							use:styles={{ fsXS, colorMain, buttonBg, buttonBgHover }}>reset</button
						>
					{/if}
				</div>
			{/if}
			{#if listMail}
				<div class="mail_content" use:styles={{ fsXS, colorMain, inputBg }}>
					{#await mailList}
						<p>...loading</p>
					{:then mails}
						{#each mails as mail}
							<div class="mail_list_row" use:styles={{ fsXS }}>
								<div>{mail}</div>
								<div on:click={() => send_single(mail)} on:keydown={() => send_single(mail)} class="send" />
								<div on:click={() => delete_mail(mail)} on:keydown={() => delete_mail(mail)} class="delete" />
							</div>
						{/each}
					{/await}
				</div>
			{/if}

			{#if archiveMail}
				<div
					class="mail_content"
					use:styles={{ fsXS, colorMain, inputBg }}
					transition:slide={{ duration: 1000, delay: 500 }}
				>
					{#await mailArchive}
						<p>...loading</p>
					{:then archive}
						{#if archive.length < 1}
							<div class="no_content">no mails sent</div>
						{:else}
							{#each archive as arch}
								<div class="mail_archive_row" use:styles={{ fsXS }}>
									<div>{arch.subject}</div>
									<div>{arch.date}</div>
									<div>{arch.email}</div>
									<div on:click={() => view_mail(arch.id)} on:keydown={() => view_mail(arch.id)} class="view" />
									<div
										on:click={() => delete_archive(arch.type, arch.id, null)}
										on:keydown={() => delete_archive(arch.type, arch.id, null)}
										class="delete"
									/>
								</div>
							{/each}
						{/if}
					{/await}
				</div>
			{/if}

			{#if showMail}
				<div
					class="show_mail"
					use:styles={{ fsXS, colorMain, inputBg }}
					transition:slide={{ duration: 1000, delay: 500 }}
				>
					{#await singleMailContent}
						...loading
					{:then mail}
						<div class="view_grid" use:styles={{ fsXS, colorMain }}>
							<div>{mail.date}</div>
							<div>{mail.subject}</div>
						</div>
						<div class="view_message" use:styles={{ fsXS, colorMain }}>{@html mail.message}</div>

						<div class="view_grid" data-receiver use:styles={{ fsXS, colorMain }}>
							<div>type:</div>
							<div>{mail.type}</div>
						</div>
						{#if mail.type === 'image'}
							{#await user then usr}
								<div class="view_grid" data-image use:styles={{ fsXS, colorMain }}>
									<div>image:</div>
									<div>
										<img src="{url}/mail_images/thumbnail/{mail.image}" alt="thumb" />
									</div>
									<div>{mail.image}</div>
								</div>
							{/await}
						{/if}
						<div class="view_button_container" use:styles={{ fsXS, buttonBgHover }}>
							<div class="view_button" use:styles={{ link, linkHover }} on:click={close_mail} on:keydown={close_mail}>
								close
							</div>
							<div
								class="view_button"
								use:styles={{ link, linkHover }}
								on:click={() => delete_archive(mail.type, mail.id, 'archive')}
								on:keydown={() => delete_archive(mail.type, mail.id, 'archive')}
							>
								delete
							</div>
						</div>
					{/await}
				</div>
			{/if}
		</div>
	</TwoCols>
</main>

{#if $storeUploader}
	<Shader>
		<div slot="content">
			<Spinner color="hsl(0,0%,60%)" size={fsS} fontSize={fsXS} info={spinnerInfo} />
		</div>
	</Shader>
{/if}

{#if alertError}
	<Shader>
		<div slot="content">
			<Alert {message} showOkButton={false} alertMessage="ERROR" on:alertclose={reset_error} />
		</div>
	</Shader>
{/if}

<style>
	main {
		user-select: none;
	}

	ul {
		margin-right: clamp(5px, 3.25vw, 50px);
		padding: 0px;
		list-style: none;
		display: flex;
		align-items: center;
	}

	.column1,
	.column2 {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		width: 100%;
		padding: 2%;
	}

	.input_container {
		position: relative;
		width: 90%;
	}

	input[data-radio],
	input[data-checkbox] {
		outline: none;
		margin: 0px;
		padding: 0px;
		width: 20px;
		height: 20px;
	}

	input[data-file],
	input[data-text],
	textarea,
	.error,
	.success {
		font-size: var(--fsXS);
		color: var(--colorMain);
		outline: none;
		border: 1px solid hsl(0, 0%, 90%);
		width: 100%;
		background-color: var(--inputBg);
	}

	input[data-text]:focus {
		background-color: var(--inputFocus);
	}

	input[data-button] {
		width: clamp(150px, 29.2vw, 450px);
		margin-right: 5px;
	}

	textarea {
		resize: none;
		height: clamp(100px, 19.5vw, 300px);
	}

	.error,
	.no_content {
		color: red;
		padding: 5px;
	}

	.success {
		color: green;
		padding: 5px;
	}

	button {
		outline: none;
		font-size: var(--fsXS);
		color: var(--colorMain);
		border-radius: 5px;
		background-color: var(--buttonBg);
		cursor: pointer;
	}

	button:hover {
		background-color: var(--buttonBgHover);
	}

	.column1,
	.column2 {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		width: 100%;
		padding: 2%;
	}

	.title {
		font-size: var(--fsL);
		color: var(--colorMain);
	}

	.sub_title {
		font-size: var(--fsXS);
		color: var(--colorMain);
		margin-right: clamp(5px, 1.3vw, 20px);
		padding: 5px;
	}

	.selection_container {
		font-size: var(--fsXS);
		color: var(--colorMain);
		display: flex;
		width: 100%;
		align-items: flex-start;
	}

	.button_container {
		display: flex;
		width: 100%;
		justify-content: flex-end;
		padding-right: 10px;
	}

	.mail_content {
		display: flex;
		flex-direction: column;
		width: clamp(250px, 39vw, 600px);
		height: clamp(100px, 19.5vw, 300px);
		border: 1px solid hsl(0, 0%, 90%);
		overflow-y: auto;
		font-size: var(--fsXS);
		color: var(--colorMain);
		background-color: var(--inputBg);
		padding: 5px;
	}

	.mail_list_row {
		display: grid;
		grid-template-columns: 70% 20% 10%;
		align-items: center;
		font-size: var(--fsXS);
	}

	.mail_archive_row {
		display: grid;
		grid-template-columns: 30% 20% 40% 5% 5%;
		align-items: center;
		font-size: var(--fsXS);
	}

	.mail_list_row:hover {
		background-color: hsl(0, 0%, 30%);
	}

	.mail_archive_row:hover {
		background-color: hsl(0, 0%, 30%);
	}

	.show_mail {
		display: flex;
		flex-direction: column;
		align-items: center;
		font-size: var(--fsXS);
		border: 1px solid var(--colorMain);
		background-color: var(--inputBg);
		color: var(--colorMain);
		padding: 5px;
		width: 100%;
		height: 100%;
	}

	.view_grid {
		width: 100%;
		display: grid;
		grid-template-columns: 20% 80%;
		font-size: var(--fsXS);
		border-bottom: 1px solid var(--colorMain);
		padding: 10px;
	}

	.view_grid[data-receiver] {
		font-size: var(--fsXS);
	}

	.view_grid[data-image] {
		font-size: var(--fsXS);
		grid-template-columns: 20% 20% 60%;
	}

	.view_message {
		width: 100%;
		height: 150px;
		overflow-y: auto;
		display: flex;
		justify-content: flex-start;
		padding: 10px;
		font-size: var(--fsXS);
		border-bottom: 1px solid var(--colorMain);
	}

	.view_button_container {
		width: 100%;
		display: flex;
		justify-content: flex-end;
		padding: 10px;
		font-size: var(--fsXS);
	}

	.view_button {
		padding: 10px;
		font-size: var(--fsXS);
		color: var(--link);
		cursor: pointer;
	}

	.view_button:hover {
		color: var(--linkHover);
	}

	.delete {
		width: 20px;
		height: 24px;
		background-image: url('/images/bin.png');
		background-size: cover;
		cursor: pointer;
	}

	.send,
	.view {
		width: 24px;
		height: 20px;
		background-image: url('/images/mail.png');
		background-size: cover;
		cursor: pointer;
	}

	.view {
		background-image: url('/images/icon_eye.png');
	}
</style>
